import { postAnon } from "../helper/http";

export class AuthService {
  static currentToken: string | null = null;

  private static dispatchTokenChange(token: string | null) {
    window.dispatchEvent(new CustomEvent('auth-token-changed', { 
      detail: { token } 
    }));
  }

  static async login(data: { login: string; password: string }) {
    const res = await postAnon("auth/sign-in", data);

    if (res.enabled2fa === true) {
      return {
        requires2fa: true,
        login: data.login
      };
    }

    const access_token = res.token;

    if (access_token) {
      this.currentToken = access_token;
      localStorage.setItem("token", access_token);
      this.dispatchTokenChange(access_token); 
    } else {
      console.warn("Token not found in server response");
    }

    return {
      requires2fa: false,
      token: access_token
    };
  }

  static async verify2fa(data: { login: string; password: string; code: string }) {
    const payload = {
      login: String(data.login),
      password: String(data.password),
      code: String(data.code).trim() 
    };
    
    const res = await postAnon("auth/sign-in-2fa", payload); 

    const access_token = res.token;

    if (access_token) {
      this.currentToken = access_token;
      localStorage.setItem("token", access_token);
      this.dispatchTokenChange(access_token);
    }

    return res;
  }

  static async register(data: { 
    login: string; 
    email: string; 
    telegramId: string;
    password: string;
  }) {
    const res = await postAnon("auth/sign-up", {
      login: data.login,
      email: data.email,
      tgId: data.telegramId,
      password: data.password,
    });
    return res;
  }

  static async requestPasswordReset(data: { login: string }) {
    const res = await postAnon("auth/reset", data);
    return res;
  }

  static async resetPassword(data: { 
    login: string;
    code: string; 
  }) {
    const res = await postAnon("auth/nw-password", data);
    return res;
  }

  static logout() {
    this.currentToken = null;
    localStorage.removeItem("token");
    this.dispatchTokenChange(null); 
  }

  static isAuthenticated(): boolean {
    const token = localStorage.getItem("token");
    if (token) {
      this.currentToken = token;
      return true;
    }
    return false;
  }

  static getToken(): string | null {
    if (this.currentToken) {
      return this.currentToken;
    }

    const token = localStorage.getItem("token");

    if (token) {
      this.currentToken = token;
      return token;
    }

    return null;
  }
}